import React from 'react';
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";
import {getLocal, setLocal} from "ubs-framework/v2/common/function";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

const initialState = {
    socketId: '',
    _id: '',
    eventList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        view: getLocal('u_ev') ? getLocal('u_ev') : 'list',
        search: '',
        status: null,
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'FILTER_EVENTS_LIST': {
            return {...state, eventList: {...state.eventList, ...action.payload}}
        }
        case 'CHANGE_EVENT_VIEW' : {
            setLocal('u_ev', action.payload);
            return {...state, eventList: {...state.eventList, view: action.payload}};
        }

        default: {
            return state;
        }
    }
}
